import { PageMeta } from "@/components/PageMeta";
import { SectionHeading } from "@/components/SectionHeading";
import { GlassPanel } from "@/components/GlassPanel";
import { CtaLink } from "@/components/Button";
import { Faq } from "@/components/Faq";
import { supportFaqs } from "@/content/faqs";
import { siteConfig } from "@/config/site";
import { routeSeo } from "@/content/seo";

export function SupportPage() {
  const seo = routeSeo["/support"];
  return (
    <>
      <PageMeta title={seo.title} description={seo.description} path="/support" />

      <section className="container page-hero">
        <p className="eyebrow">Support</p>
        <h1 className="page-hero-title">Getting help with Devory</h1>
        <p className="page-hero-lede">
          Devory is a small, actively developing team. Support today is handled directly rather than
          through a large ticketing system, and here is exactly how it works.
        </p>
      </section>

      <section className="container section">
        <div className="grid-3">
          <GlassPanel as="article" className="audience-card">
            <SectionHeading
              level={3}
              title="How to reach support"
              lede="Use the contact form and select the category closest to your question, or email Devory directly."
            />
            <CtaLink to="/contact" variant="secondary">
              Open contact form
            </CtaLink>
          </GlassPanel>
          <GlassPanel as="article" className="audience-card">
            <SectionHeading
              level={3}
              title="Account and access issues"
              lede="Sign up or sign in at app.devory.app. If you have an access problem with your account or organisation, use the contact form and mention your organisation."
            />
          </GlassPanel>
          <GlassPanel as="article" className="audience-card">
            <SectionHeading
              level={3}
              title="Billing support"
              lede="Subscriptions are billed through Stripe and managed from Settings > Billing inside Devory Cloud. For a billing question the contact form reaches a real person."
            />
            <CtaLink to="/pricing" variant="secondary">
              View pricing status
            </CtaLink>
          </GlassPanel>
        </div>
      </section>

      <section className="container section-tight" aria-labelledby="support-faq-heading">
        <GlassPanel className="problem-card">
          <SectionHeading level={2} title={<span id="support-faq-heading">Support FAQ</span>} />
          <Faq items={supportFaqs} />
        </GlassPanel>
      </section>

      <section className="container section-tight">
        <GlassPanel className="cta-banner">
          <h2>Still need help?</h2>
          <p>
            Email <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a> or use
            the contact form.
          </p>
          <div className="cta-banner-actions">
            <CtaLink to="/contact" variant="primary">
              Contact Devory
            </CtaLink>
          </div>
        </GlassPanel>
      </section>
    </>
  );
}
